// extracted by mini-css-extract-plugin
module.exports = {"enhanced-tabs-wrapper":"EnhancedTabs__enhanced-tabs-wrapper___2C6MA"};